export default __webpack_public_path__ + "static/media/equalizer-line 1.904edacd.svg";